import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { clubApi } from "../../club-api-client";
import { queryKeys } from "../query-keys";

export function useTrainingSessions(
	clubId: string | null,
	seasonId: string | null,
	params?: { group_id?: string; after_date?: string },
) {
	return useQuery({
		enabled: !!clubId && !!seasonId,
		queryFn: () => clubApi.training.sessions.list(clubId!, seasonId!, params),
		queryKey: [
			...queryKeys.clubPortal.trainingSessions(clubId ?? "", seasonId ?? ""),
			"list",
			params ?? {},
		],
	});
}

export function useCancelTrainingSession(clubId: string) {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: ({ seasonId, eventId }: { seasonId: string; eventId: string }) =>
			clubApi.training.sessions.cancel(clubId, seasonId, eventId),
		onSuccess: () =>
			qc.invalidateQueries({
				queryKey: ["club-portal", "clubs", clubId, "training"],
			}),
	});
}

export function useDeleteTrainingSessions(clubId: string) {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: ({
			seasonId,
			groupId,
			afterDate,
		}: {
			seasonId: string;
			groupId?: string;
			afterDate?: string;
		}) => clubApi.training.sessions.deleteAll(clubId, seasonId, groupId, afterDate),
		onSuccess: () => {
			qc.invalidateQueries({
				queryKey: ["club-portal", "clubs", clubId, "training"],
			});
			qc.invalidateQueries({
				queryKey: ["club-portal", "clubs", clubId, "events"],
			});
		},
	});
}
